import SectionLabel from "@/components/SectionLabel";
import { Sparkles, BookText, FilePenLine } from "lucide-react";

const ROADMAP = [
  {
    tag: "Q1",
    title: "Regulatory RAG for citations",
    icon: BookText,
    body: "Cite the exact provision behind every Sentinel score — deterministically.",
  },
  {
    tag: "Q2",
    title: "Rule Generation Agent",
    icon: Sparkles,
    body: "Propose, simulate and version new typology rules. Officer approves.",
  },
  {
    tag: "Q3",
    title: "SAR Drafting Agent",
    icon: FilePenLine,
    body: "Draft SARs with structured evidence and immutable data retention.",
  },
];

const Roadmap = () => {
  return (
    <section
      data-testid="roadmap-section"
      className="dark-section relative py-24 lg:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 bg-dot-grid opacity-40" />
      <div className="relative max-w-[1380px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-end mb-16">
          <div className="lg:col-span-7">
            <SectionLabel index="08" label="What's next" dark />
            <h2 className="mt-6 font-display font-bold text-white text-4xl sm:text-5xl lg:text-[58px] tracking-tight leading-[1.02]">
              Advisory AI,<br />
              <span className="text-white/55">built the same way.</span>
            </h2>
          </div>
          <div className="lg:col-span-5">
            <p className="text-white/65 text-[17px] leading-relaxed">
              Three advisory agents extend Sentinel into citation, rule-authoring
              and reporting — on the same deterministic, advisory-only
              rails.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {ROADMAP.map((r, i) => {
            const Icon = r.icon;
            const ACCENTS = [
              { hex: "#00e5ff", soft: "rgba(0,229,255,0.12)" },
              { hex: "#7c3aed", soft: "rgba(124,58,237,0.18)" },
              { hex: "#f59e0b", soft: "rgba(245,158,11,0.16)" },
            ];
            const a = ACCENTS[i % ACCENTS.length];
            return (
              <div
                key={r.title}
                data-testid={`roadmap-${i}`}
                className="bg-[#0d0e16] p-8 lg:p-10 flex flex-col gap-6 min-h-[260px] relative"
              >
                <span
                  className="absolute top-0 left-0 right-0 h-[3px]"
                  style={{ backgroundColor: a.hex }}
                />
                <div className="flex items-center justify-between">
                  <span
                    className="font-mono text-[11px] tracking-[0.22em] uppercase"
                    style={{ color: a.hex }}
                  >
                    {r.tag}
                  </span>
                  <span
                    className="inline-flex items-center justify-center w-10 h-10"
                    style={{ backgroundColor: a.soft }}
                  >
                    <Icon
                      className="w-5 h-5"
                      style={{ color: a.hex }}
                      strokeWidth={2}
                    />
                  </span>
                </div>
                <div>
                  <p className="font-display font-bold text-white text-[22px] tracking-tight">
                    {r.title}
                  </p>
                  <p className="mt-3 text-white/65 text-[14px] leading-relaxed">
                    {r.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
